/**
 * Returns the subdomain of a hostname string
 */
export default function getSubdomain(hostname: string, domain: string): string {
  // If `hostname` and `domain` are the same, then there is no sub-domain
  if (domain.length === hostname.length) {
    return '';
  }

  return hostname.slice(0, -domain.length - 1);
}
